import Vue from 'vue'
import Vuex from 'vuex'

import { Article } from '@/models'

import ogs from 'open-graph-scraper'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    articles: [],
    lastId: -1,
  },
  mutations: {
    add(state,payload){
      let article = payload.article;
      Vue.set(state.articles,article.id,article);
      state.lastId = article.id;
    },
    setArticleImage(state,payload){
      Vue.set(payload.article,'img',payload.image);
    }
  },
  actions: {
    createAndAdd({commit,state},payload) {
      let article = new Article();
      article.rss = payload.rss;
      article.imgtag = payload.imgtag;
      article.id = state.lastId+1;
      article.idSource = payload.idSource;
      commit('add', {article: article});
    },
    async setDataFromOG({commit,dispatch,rootState},payload) {

      let storageName = 'og/'+payload.article.rss.link;
      await dispatch('loadLocal', {name: storageName, expire: 60*24}, {root: true}).then((response) => {
        commit('setArticleImage',{article: payload.article, image: response.data})
      }, async () => {
        //console.log(error)
        //console.log("Scrape OG: " + payload.article.rss.link)
        let url = rootState.corsProxy+payload.article.rss.link
        await ogs({'url': url}, function (error, results) {
          if(error){
            console.log(error)
          }
          else if(results){
            let image = results.data.ogImage.url
            commit('saveLocal', {name: storageName, data: image}, {root: true})
            commit('setArticleImage',{article: payload.article, image: image})
          }
        });
      })
    },
  },
  getters: {
    articlesBySourceId: (state) => (idSource) => {
      return state.articles.filter(a => a.idSource == idSource)
    },
    articlesByChamberId: (state, getters, rootState, rootGetters) => (idChamber,active) => {
      let articles = []
      let sources = rootGetters['sources/sourcesByChamberId'](idChamber,active)
      sources.forEach((source) => {
        articles = articles.concat(getters.articlesBySourceId(source.id))
      });

      articles.sort(function(a, b) {
        return Date.parse(b.rss.pubDate) - Date.parse(a.rss.pubDate);
      });

      return articles
    },
  },
  modules: {
  }
}
